import { Link } from "react-router-dom";
import { getByType } from "@/lib/media";

const entries = [
  {
    to: "/category/movie",
    label: "电影专区",
    desc: "最新中文字幕电影 · 高清资源资讯",
    count: getByType("movie").length,
    icon: "ri-film-line",
    image:
      "https://readdy.ai/api/search-image?query=Cinematic%20wide%20film%20backdrop%2C%20a%20lone%20astronaut%20standing%20before%20a%20vast%20glowing%20ocean%20of%20stars%2C%20epic%20atmospheric%20lighting%20with%20deep%20navy%20blue%20and%20warm%20amber%20tones%2C%20subtle%20film%20grain%2C%20minimal%20clean%20composition%20with%20space%20for%20text%2C%20professional%20editorial%20photography%2C%20high%20detail%2C%20moody%2C%20consistent%20series%20style&width=800&height=500&seq=hero-m01&orientation=landscape",
  },
  {
    to: "/category/tv",
    label: "电视剧专区",
    desc: "热播剧集中文字幕 · 剧集持续更新",
    count: getByType("tv").length,
    icon: "ri-tv-2-line",
    image:
      "https://readdy.ai/api/search-image?query=Cinematic%20wide%20film%20backdrop%2C%20an%20ancient%20Chinese%20courtyard%20at%20night%20lit%20by%20red%20lanterns%2C%20epic%20atmospheric%20lighting%20with%20deep%20navy%20blue%20and%20warm%20amber%20tones%2C%20subtle%20film%20grain%2C%20minimal%20clean%20composition%20with%20space%20for%20text%2C%20professional%20editorial%20photography%2C%20high%20detail%2C%20moody%2C%20consistent%20series%20style&width=800&height=500&seq=hero-t01&orientation=landscape",
  },
];

export default function CategoryEntries() {
  return (
    <div className="grid grid-cols-1 gap-4 md:grid-cols-2 md:gap-6">
      {entries.map((entry) => (
        <Link
          key={entry.to}
          to={entry.to}
          className="group relative h-[180px] overflow-hidden rounded-lg border border-background-200 md:h-[200px]"
        >
          <img
            src={entry.image}
            alt={`${entry.label}背景图`}
            title={`${entry.label} - 最近中文字幕`}
            className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-primary-950/90 via-primary-950/60 to-primary-950/20"></div>
          <div className="absolute inset-0 flex flex-col justify-center p-5 md:p-7">
            <span className="flex h-10 w-10 items-center justify-center rounded-md bg-accent-500 text-xl text-primary-950">
              <i className={entry.icon}></i>
            </span>
            <h3 className="mt-3 font-heading text-xl font-bold text-background-50">
              {entry.label}
            </h3>
            <p className="mt-1 text-sm text-background-200">{entry.desc}</p>
            <span className="mt-3 flex items-center gap-1 text-sm text-accent-300">
              共 {entry.count} 部作品
              <i className="ri-arrow-right-line transition-transform group-hover:translate-x-1"></i>
            </span>
          </div>
        </Link>
      ))}
    </div>
  );
}